import React from 'react';
import '../QueuePage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';


const QueueTableNoResults = () => (
    <div className="columns light-grey">
        <div className='column is-12 has-text-centered'>
            <HrbTranslate className='p1 pb-4' text='QueuePage.Labels.None' />
        </div>
    </div>
);

export default QueueTableNoResults